import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function CMSPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/cms/${slug}`).then((r) => setPage(r.data)).catch(() => setPage({ title: "Not Found", content: "This page is not available." })); }, [slug]);

  const description = page?.content
    ? String(page.content).replace(/\s+/g, " ").slice(0, 160)
    : "VenturaZ policy and information pages.";

  return (
    <div className="min-h-screen bg-transparent text-ink">
      <Seo
        title={`${page?.title || "VenturaZ"} | VenturaZ`}
        description={description}
        path={`/cms/${slug}`}
        type="article"
      />
      <PublicNavbar />
      <section className="max-w-[900px] mx-auto px-6 lg:px-10 py-20" data-testid="cms-page">
        <div className="overline mb-3">VENTURAZ · POLICY</div>
        <h1 className="font-display text-3xl lg:text-5xl text-ink leading-tight">{page?.title}</h1>
        <div className="mt-8 border border-white/10 bg-white/70 backdrop-blur p-8 text-ink-soft leading-relaxed whitespace-pre-line" data-testid="cms-content">
          {page?.content}
        </div>
      </section>
      <Footer />
    </div>
  );
}
